import SwapAndBridgeIcon from './SwapAndBridgeIcon'

export default SwapAndBridgeIcon
